import { type Reducer, type UnknownAction, combineReducers } from 'redux';
import type { RootState } from '../types/redux';
import { auth } from './auth/reducers';
// import { catalog } from './catalog/reducers'; // MOVED TO EDITOR
import { editor } from './editor/reducers';
import { commonEditorPara } from './editor_para/reducers';

const baseReducer = combineReducers({
  auth,
  // catalog, // MOVED TO EDITOR - now part of editor.catalog
  commonEditorPara,
  editor,
  // paragraph removed - no longer needed
});

const rootReducer: Reducer<RootState, UnknownAction> = (state, action) => {
  // Reset state on logout
  const currentState = action.type === 'USER_LOGOUT' ? undefined : state;

  // Run combined reducers - cast needed for Redux 5 compatibility
  // (combineReducers handles unknown actions by returning default state)
  return baseReducer(currentState, action as Parameters<typeof baseReducer>[1]);
};

export { rootReducer };
